/**
 * Censo Hogueras
 * Censo-Hogueras
 *
 * OpenAPI spec version: 1.0.0
 * Contact: you@your-company.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ResponseStatus } from '../model/responseStatus';
import { ResponseTipoAsociaciones } from '../model/responseTipoAsociaciones';
import { Status } from '../model/status';
import { TipoAsociacion } from '../model/tipoAsociacion';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({providedIn: 'root'})
export class TipoAsociacionesService {

    protected basePath = 'https://virtserver.swaggerhub.com/emjf1/Censo-Hogueras/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Eliminar un tipo asociado
     * 
     * @param idTipoAsociacion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tipoasociacionesDelete(idTipoAsociacion: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseStatus>;
    public tipoasociacionesDelete(idTipoAsociacion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseStatus>>;
    public tipoasociacionesDelete(idTipoAsociacion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseStatus>>;
    public tipoasociacionesDelete(idTipoAsociacion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idTipoAsociacion === null || idTipoAsociacion === undefined) {
            throw new Error('Required parameter idTipoAsociacion was null or undefined when calling tipoasociacionesDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseStatus>('delete',`${this.basePath}/tipoasociaciones/${encodeURIComponent(String(idTipoAsociacion))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar todos los tipos de asociados
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tipoasociacionesGet(observe?: 'body', reportProgress?: boolean): Observable<ResponseTipoAsociaciones>;
    public tipoasociacionesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseTipoAsociaciones>>;
    public tipoasociacionesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseTipoAsociaciones>>;
    public tipoasociacionesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseTipoAsociaciones>('get',`${this.basePath}/tipoasociaciones`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener un tipo asociado
     * 
     * @param idTipoAsociacion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tipoasociacionesGetById(idTipoAsociacion: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseTipoAsociaciones>;
    public tipoasociacionesGetById(idTipoAsociacion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseTipoAsociaciones>>;
    public tipoasociacionesGetById(idTipoAsociacion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseTipoAsociaciones>>;
    public tipoasociacionesGetById(idTipoAsociacion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idTipoAsociacion === null || idTipoAsociacion === undefined) {
            throw new Error('Required parameter idTipoAsociacion was null or undefined when calling tipoasociacionesGetById.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseTipoAsociaciones>('get',`${this.basePath}/tipoasociaciones/${encodeURIComponent(String(idTipoAsociacion))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crear un nuevo tipo asociado
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tipoasociacionesPost(body: TipoAsociacion, observe?: 'body', reportProgress?: boolean): Observable<ResponseTipoAsociaciones>;
    public tipoasociacionesPost(body: TipoAsociacion, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseTipoAsociaciones>>;
    public tipoasociacionesPost(body: TipoAsociacion, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseTipoAsociaciones>>;
    public tipoasociacionesPost(body: TipoAsociacion, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling tipoasociacionesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseTipoAsociaciones>('post',`${this.basePath}/tipoasociaciones`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Actualizar un tipo asociado
     * 
     * @param body 
     * @param idTipoAsociacion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tipoasociacionesPut(body: TipoAsociacion, idTipoAsociacion: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseTipoAsociaciones>;
    public tipoasociacionesPut(body: TipoAsociacion, idTipoAsociacion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseTipoAsociaciones>>;
    public tipoasociacionesPut(body: TipoAsociacion, idTipoAsociacion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseTipoAsociaciones>>;
    public tipoasociacionesPut(body: TipoAsociacion, idTipoAsociacion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling tipoasociacionesPut.');
        }

        if (idTipoAsociacion === null || idTipoAsociacion === undefined) {
            throw new Error('Required parameter idTipoAsociacion was null or undefined when calling tipoasociacionesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseTipoAsociaciones>('put',`${this.basePath}/tipoasociaciones/${encodeURIComponent(String(idTipoAsociacion))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
